import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=d2a33d06&"
import script from "./Editor.vue?vue&type=script&lang=ts&"
export * from "./Editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d2a33d06', component.options)
    } else {
      api.reload('d2a33d06', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=d2a33d06&", function () {
      api.rerender('d2a33d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/MdEditor/Editor.vue"
export default component.exports